import '../styling/global.css';
import { Link } from 'react-router-dom';

import service1 from '../assets/1.webp';
import service2 from '../assets/2.webp';
import service3 from '../assets/3.webp';
import service4 from '../assets/4.webp';
import service5 from '../assets/5.webp';
import service6 from '../assets/6.webp';
import BackgroundEffect from '../components/BackgroundEffect';

// 🔧 Utility function to convert feature to slug
const slugify = (text) =>
  text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

const servicesData = [
  {
    id: 1,
    title: 'AI & Data Services',
    image: service1,
    features: [
      'Internet & Web Research Services',
      'Sentiment Analysis',
      'Search Relevance',
      'Search Data Testing',
      'Product Data Management',
      'Store Checks',
      'Mystery Checks',
      'Surveys'
    ]
  },
  {
    id: 2,
    title: 'Data Annotation & Dataset Solutions',
    image: service2,
    features: [
      'Categorization & Tagging',
      'Product Categorization & Tagging',
      'Image & Video Tagging',
      'Video Analysis',
      'Image Annotation',
      'Human in the Loop Services',
      'AI Content Editing & Creation'
    ]
  },
  {
    id: 3,
    title: 'AI Training Dataset Development',
    image: service3,
    features: [
      'AI Datasets for ML',
      'Audio & Voice Datasets',
      'LLM Dataset Services',
      'Image & Photo Datasets',
      'Face Recognition Training Data',
      'Video Datasets'
    ]
  },
  {
    id: 4,
    title: 'Testing & Quality Assurance',
    image: service4,
    features: [
      'Mobile App Testing',
      'Store Checks (QA field audits)',
      'Search Data Test',
      'Mystery Checks (Customer experience QA)'
    ]
  },
  {
    id: 5,
    title: 'App & Web Development',
    image: service5,
    features: [
      'Mobile App Development (iOS & Android)',
      'Website Development',
      'Web App UI/UX Design',
      'Template Design'
    ]
  },
  {
    id: 6,
    title: 'Creative & Graphic Design Services',
    image: service6,
    features: [
      'Logo Design',
      'Website and App Design',
      'Social Media Graphics',
      'Print Materials Design',
      'Presentation Design',
      'Brand Kit Development',
      'Marketing Materials Design',
      'Video and Image Editing'
    ]
  }
];

const Services = () => {
  return (
    <div className="services-container">
      <BackgroundEffect />
      <h1 className="services-heading">Our Services</h1>
      {servicesData.map((service, index) => (
        <div
          key={service.id}
          className={`service-row ${index % 2 !== 0 ? 'reverse' : ''}`}
        >
          <img
            src={service.image}
            alt={`Service ${service.id}`}
            className="service-img"
          />
          <div className="service-content">
            <h2 className="service-title">{service.title}</h2>
            <ul className="service-list">
              {service.features.map((feature, idx) => (
                <li key={idx}>
                  <Link
                    to={`/services/section/${service.id}#${slugify(feature)}`}
                    className="feature-link"
                  >
                    {feature}
                  </Link>
                </li>
              ))}
            </ul>
            <Link to={`/services/section/${service.id}`} className="learn-more-btn">
              Learn More <span className="arrow">→</span>
            </Link>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Services;